<template>
  <div class="box">
    <div class="columns is-multiline">
      <div class="column is-12">
        <table class="table is-fullwidth">
          <tr>
            <th>Name</th>
            <th>Substitute</th>
            <th>Present / Not Present</th>
            <th>Present Time</th>
          </tr>
          <tr v-for="(member_row, index) in member_list" :key="index">
            <td v-text="member_row.name"></td>
            <td v-text="member_row.substitute_name"></td>
            <td>
              <button v-show="member_list[index].present === 0" class="button is-success" @click="memberPresent(member_row, index)">Present</button>
              <button v-show="member_list[index].present === 1" class="button is-danger" @click="memberNotPresent(member_row, index)">Not Present</button>
            </td>
            <td v-text="member_row.present_time"></td>
          </tr>
        </table>
      </div>
      <div class="column is-12">
        <div class="field">
          <label class="label">Search Name</label>
          <div class="control">
            <input type="text" class="input" v-model="search_member">
          </div>
        </div>
        <table class="table is-fullwidth">
          <tr>
            <th>Name</th>
            <th>Add to Team</th>
          </tr>
          <tr v-for="(other_member_row, index) in filteredOtherMembers" :key="index">
            <td v-text="other_member_row.name"></td>
            <td><button class="button is-link" @click="addOtherMember(other_member_row, index)">Add to Team</button></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      member_list: [],
      selected_other_member: '',
      other_member_list: [
        {
          id: '003',
          name: 'Anton'
        },
        {
          id: '004',
          name: 'Yandi'
        },
        {
          id: '005',
          name: 'Elizia'
        },
        {
          id: '006',
          name: 'Martin'
        }
      ],
      search_member: ''
    }
  },
  created () {
    this.member_list = [
      {
        id: '001',
        name: 'Budi',
        present: 0,
        present_time: ''
      },
      {
        id: '002',
        name: 'Budiana',
        present: 1,
        present_time: this.getTimeNow()
      },
      {
        id: '003',
        name: 'Jenny',
        substitute_name: '',
        present: 0,
        present_time: ''
      },
      {
        id: '004',
        name: 'Morin',
        substitute_name: 'Allen',
        present: 0,
        present_time: ''
      }
    ]
  },
  computed: {
    filteredOtherMembers () {
      var self = this
      return this.other_member_list.filter(function (data) {
        return data.name.toLowerCase().indexOf(self.search_member.toLowerCase()) >= 0
      })
    }
  },
  methods: {
    memberPresent (dataRow, index) {
      this.member_list[index].present = 1
      this.member_list[index].present_time = this.getTimeNow()
    },
    memberNotPresent (dataRow, index) {
      this.member_list[index].present = 0
      this.member_list[index].present_time = ''
    },
    addOtherMember (dataRow, index) {
      var otherMemberData = {
        id: this.other_member_list[index].id,
        name: this.other_member_list[index].name,
        present: 1,
        present_time: this.getTimeNow()
      }

      this.other_member_list.splice(index, 1)

      this.selected_other_member = ''

      this.member_list.push(otherMemberData)
    },
    getTimeNow () {
      var objDate = new Date()
      return objDate.getHours() + ':' + objDate.getMinutes()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/teamleader/Attendance.vue